<template>
	<div>
		<div v-if="isPetugasPresensi">
			<el-divider content-position="left" border-style="dotted">Tambah Izin</el-divider>
			<el-form
				:model="formCreate"
				:rules="rulesCreate"
				ref="formCreate"
				@submit.prevent="insertIzinPresensi"
				label-position="top"
				:disabled="inserting"
				require-asterisk-position="right"
				:validate-on-rule-change="false">
				<div class="row g-3">
					<div class="col-12 col-sm-8 col-md-6 col-xxl-4">
						<el-form-item label="Non-GTK" prop="user_presensi_id" class="mb-0">
							<el-select v-model="formCreate.user_presensi_id" filterable placeholder="Pilih non-gtk" clearable>
								<el-option v-for="u in listUser" :key="u.non_gtk_id" :label="`${u.nama} (${u.user_presensi_id})`" :value="u.user_presensi_id" />
							</el-select>
						</el-form-item>
					</div>
					<div class="col-12 col-sm-4 col-md-3 col-xxl-2">
						<el-form-item label="Tanggal" prop="tanggal" class="mb-0">
							<el-date-picker v-model="formCreate.tanggal" format="DD MMMM YYYY" value-format="YYYY-MM-DD" placeholder="Tanggal" class="w-100" />
						</el-form-item>
					</div>
					<div class="col-12 col-sm-4 col-md-3 col-xxl-2">
						<el-form-item label="Izin Masuk" prop="izin_masuk" class="mb-0">
							<el-select v-model="formCreate.izin_masuk" placeholder="Jenis izin" clearable>
								<el-option v-for="i in jenisMasukPulang" :key="i" :label="i" :value="i" />
							</el-select>
						</el-form-item>
					</div>
					<div class="col-12 col-sm-4 col-md-3 col-xxl-2">
						<el-form-item label="Izin Pulang" prop="izin_pulang" class="mb-0">
							<el-select v-model="formCreate.izin_pulang" placeholder="Jenis izin" clearable>
								<el-option v-for="i in jenisMasukPulang" :key="i" :label="i" :value="i" />
							</el-select>
						</el-form-item>
					</div>
					<div class="col-12 col-sm-4 col-md-3 col-xxl-2">
						<el-form-item label="Izin Penuh" prop="izin_penuh" class="mb-0">
							<el-select v-model="formCreate.izin_penuh" placeholder="Jenis izin" clearable>
								<el-option v-for="i in jenisPenuh" :key="i" :label="i" :value="i" />
							</el-select>
						</el-form-item>
					</div>
					<div class="col-12 col-sm-8 col-md-6 col-xxl-4">
						<el-form-item label="Keterangan" prop="keterangan" class="mb-0">
							<el-input v-model="formCreate.keterangan" autosize type="textarea" placeholder="Keterangan izin" />
						</el-form-item>
					</div>
				</div>
				<el-form-item class="mt-3">
					<el-button type="success" round native-type="submit" :loading="inserting" class="ms-auto">Simpan</el-button>
				</el-form-item>
			</el-form>
		</div>
		<el-divider content-position="left" border-style="dotted">Filter</el-divider>
		<el-form label-width="auto" label-position="top">
			<div class="row g-3">
				<div class="col-12 col-sm-8 col-md-6 col-xxl-4">
					<el-form-item label="Non-GTK" prop="user_presensi_id" class="mb-0">
						<el-select v-model="izinFilter.user_presensi_id" filterable placeholder="Pilih non-gtk" clearable>
							<el-option v-for="u in listUser" :key="u.non_gtk_id" :label="`${u.nama} (${u.user_presensi_id})`" :value="u.user_presensi_id" />
						</el-select>
					</el-form-item>
				</div>
				<div class="col-12 col-md-6">
					<el-form-item label="Tanggal" prop="tanggal" class="mb-0">
						<el-date-picker
							v-model="izinFilter.tanggal"
							type="daterange"
							range-separator="s/d"
							format="DD MMMM YYYY"
							value-format="YYYY-MM-DD"
							start-placeholder="Tanggal Awal"
							end-placeholder="Tanggal Akhir" />
					</el-form-item>
				</div>
			</div>
		</el-form>
		<el-form :model="formEdit" :rules="rulesEdit" ref="formEdit" @submit.prevent="updateIzinPresensi" :disabled="updating">
			<el-table :data="izinPresensi" row-key="izin_presensi_id" table-layout="auto" v-loading="loading" :cell-class-name="cellClass">
				<template #empty>
					<span>{{ loading ? "Memuat..." : "Data tidak ditemukan" }}</span>
				</template>
				<el-table-column type="index" label="No." :index="indexMethod" />
				<el-table-column label="Nama" prop="nama">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="user_presensi_id" class="mb-0" v-if="rowEditing === row">
								<el-select v-model="formEdit.user_presensi_id" filterable :placeholder="row.nama" clearable style="min-width: 160px">
									<el-option v-for="u in listUser" :key="u.non_gtk_id" :label="`${u.nama} (${u.user_presensi_id})`" :value="u.user_presensi_id" />
								</el-select>
							</el-form-item>
							<div class="hstack gap-1 justify-content-between" v-else>
								<transition name="fade" mode="out-in">
									<span :key="row.nama">{{ row.nama }}</span>
								</transition>
								<el-tooltip :content="row.is_confirmed ? 'Kontak terkonfirmasi' : 'Belum konfirmasi'" placement="right">
									<transition name="fade" mode="out-in">
										<el-icon v-if="row.is_confirmed" class="text-bg-success rounded-circle"><CircleCheck /></el-icon>
										<el-icon v-else class="text-warning"><Warning /></el-icon>
									</transition>
								</el-tooltip>
							</div>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="ID Presensi" prop="user_presensi_id">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<span :key="row.user_presensi_id">{{ row.user_presensi_id }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Hari/Tanggal" prop="tanggal_izin">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="tanggal" class="mb-0" v-if="rowEditing === row">
								<el-date-picker v-model="formEdit.tanggal" format="DD MMMM YYYY" value-format="YYYY-MM-DD" :placeholder="row.tanggal_izin" />
							</el-form-item>
							<span v-else :key="row.ranggal">{{ row.tanggal_izin }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Izin Masuk" prop="izin_masuk">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<div v-if="rowEditing === row">
								<el-form-item prop="izin_masuk" class="mb-0">
									<el-select v-model="formEdit.izin_masuk" :placeholder="row.izin_masuk || 'Jenis izin'" clearable style="min-width: 125px">
										<el-option v-for="i in jenisMasukPulang" :key="i" :label="i" :value="i" />
									</el-select>
								</el-form-item>
								<el-form-item prop="del_izin_masuk" class="mb-0">
									<el-checkbox v-model="formEdit.del_izin_masuk" label="Kosongkan" size="small" :disabled="!row.izin_masuk" />
								</el-form-item>
							</div>
							<span v-else :key="row.izin_masuk">{{ row.izin_masuk || "-" }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Izin Pulang" prop="izin_pulang">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<div v-if="rowEditing === row">
								<el-form-item prop="izin_pulang" class="mb-0">
									<el-select v-model="formEdit.izin_pulang" :placeholder="row.izin_pulang || 'Jenis izin'" clearable style="min-width: 125px">
										<el-option v-for="i in jenisMasukPulang" :key="i" :label="i" :value="i" />
									</el-select>
								</el-form-item>
								<el-form-item prop="del_izin_pulang" class="mb-0">
									<el-checkbox v-model="formEdit.del_izin_pulang" label="Kosongkan" size="small" :disabled="!row.izin_pulang" />
								</el-form-item>
							</div>
							<span v-else :key="row.izin_pulang">{{ row.izin_pulang || "-" }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Izin Penuh" prop="izin_penuh">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-form-item prop="izin_penuh" class="mb-0" v-if="rowEditing === row">
								<el-select v-model="formEdit.izin_penuh" :placeholder="row.izin_penuh || 'Jenis izin'" clearable style="min-width: 125px">
									<el-option v-for="i in jenisPenuh" :key="i" :label="i" :value="i" />
								</el-select>
							</el-form-item>
							<span v-else :key="row.izin_penuh">{{ row.izin_penuh || "-" }}</span>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Keterangan" prop="keterangan">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<div v-if="rowEditing === row">
								<el-form-item prop="keterangan" class="mb-0">
									<el-input type="textarea" :rows="1" v-model="formEdit.keterangan" inline-prompt :placeholder="row.keterangan || 'Keterangan izin'" style="min-width: 160px" />
								</el-form-item>
								<el-form-item prop="del_keterangan" class="mb-0">
									<el-checkbox v-model="formEdit.del_keterangan" label="Kosongkan" size="small" :disabled="!row.keterangan" />
								</el-form-item>
							</div>
							<div class="hstack gap-1 justify-content-between" v-else :key="row.keterangan">
								{{ row.keterangan || "-" }}
								<el-tooltip>
									<template #content>
										Dibuat: <em>{{ row.created_at }}</em>
										<br />
										Diperbarui: <em>{{ row.updated_at || "-" }}</em>
									</template>
									<el-icon><i class="bi bi-info-circle"></i></el-icon>
								</el-tooltip>
							</div>
						</transition>
					</template>
				</el-table-column>
				<el-table-column label="Tindakan" v-if="isPetugasPresensi">
					<template #default="{ row }">
						<transition name="fade" mode="out-in">
							<el-space :spacer="spacer" :size="2" v-if="rowEditing === row">
								<el-button type="info" size="small" plain round @click="rowEditing = null">Batal</el-button>
								<el-button type="success" size="small" round native-type="submit" :loading="updating">Simpan</el-button>
							</el-space>
							<el-space :spacer="spacer" :size="2" v-else>
								<el-tooltip content="Edit data">
									<el-button type="primary" size="small" icon="Edit" plain round @click="rowEditing = row" />
								</el-tooltip>
								<el-tooltip content="Hapus data">
									<el-button type="danger" size="small" icon="Delete" plain round :loading="deleting === row" @click="confirmDelete(row)" />
								</el-tooltip>
							</el-space>
						</transition>
					</template>
				</el-table-column>
			</el-table>
		</el-form>
		<el-pagination
			class="flex-wrap justify-content-center mt-3"
			v-model:current-page="currentPage"
			v-model:page-size="pageSize"
			:page-sizes="[5, 10, 25, 50, 100]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="totalData"
			@change="getIzinPresensi" />
	</div>
</template>

<script>
import { ElDivider } from "element-plus";
import { h } from "vue";

export default {
	name: "IzinNonGtk",
	data() {
		return {
			spacer: h(ElDivider, { direction: "vertical" }),
			izinPresensi: [],
			listUser: [],
			formCreate: {
				user_presensi_id: null,
				tanggal: null,
				izin_masuk: null,
				izin_pulang: null,
				izin_penuh: null,
				keterangan: null,
			},
			rowEditing: null,
			formEdit: {
				user_presensi_id: null,
				tanggal: null,
				izin_masuk: null,
				del_izin_masuk: false,
				izin_pulang: null,
				del_izin_pulang: false,
				izin_penuh: null,
				keterangan: null,
				del_keterangan: false,
			},
			izinFilter: {
				user_presensi_id: null,
				tanggal: null,
			},
			rulesCreate: {
				user_presensi_id: [{ required: true, message: "Silakan pilih pengguna", trigger: "change" }],
				tanggal: [{ required: true, message: "Silakan pilih tanggal izin", trigger: "change" }],
				izin_masuk: [{ required: true, message: "Silakan pilih jenis izin masuk", trigger: "change" }],
				izin_pulang: [{ required: true, message: "Silakan pilih jenis izin pulang", trigger: "change" }],
				izin_penuh: [{ required: true, message: "Silakan pilih jenis izin penuh", trigger: "change" }],
			},
			rulesEdit: {},
			debounceFetch: null,
			inserting: false,
			loading: true,
			updating: false,
			deleting: false,
			currentPage: 1,
			totalData: 0,
			pageSize: 10,
		};
	},
	props: {
		updateEditing: Function,
		isPetugasPresensi: Boolean,
		jenisMasukPulang: Array,
		jenisPenuh: Array,
	},
	computed: {
		formEditChanged() {
			return (
				this.rowEditing !== null &&
				(this.formEdit.user_presensi_id ||
					this.formEdit.tanggal ||
					this.formEdit.izin_masuk ||
					this.formEdit.del_izin_masuk ||
					this.formEdit.izin_pulang ||
					this.formEdit.del_izin_pulang ||
					this.formEdit.izin_penuh ||
					this.formEdit.keterangan ||
					this.formEdit.del_keterangan)
			);
		},
	},
	watch: {
		"izinFilter.user_presensi_id"() {
			clearTimeout(this.debounceFetch);

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getIzinPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		"izinFilter.tanggal"(newVal, oldVal) {
			if (JSON.stringify(newVal) === JSON.stringify(oldVal)) return;

			clearTimeout(this.debounceFetch);

			this.debounceFetch = setTimeout(() => {
				if (this.currentPage === 1) this.getIzinPresensi();
				else this.currentPage = 1;
			}, 0);
		},
		"formCreate.izin_masuk"(val) {
			if (val) {
				this.formCreate.izin_penuh = null;
				this.rulesCreate.izin_pulang = [{ required: false, message: "", trigger: "change" }];
				this.rulesCreate.izin_penuh = [{ required: false, message: "", trigger: "change" }];
				return;
			}
			if (!this.formCreate.izin_pulang && !this.formCreate.izin_penuh) {
				this.rulesCreate.izin_masuk = [{ required: true, message: "Silakan pilih jenis izin masuk", trigger: "change" }];
				this.rulesCreate.izin_pulang = [{ required: true, message: "Silakan pilih jenis izin pulang", trigger: "change" }];
				this.rulesCreate.izin_penuh = [{ required: true, message: "Silakan pilih jenis izin penuh", trigger: "change" }];
			}
		},
		"formCreate.izin_pulang"(val) {
			if (val) {
				this.formCreate.izin_penuh = null;
				this.rulesCreate.izin_masuk = [{ required: false, message: "", trigger: "change" }];
				this.rulesCreate.izin_penuh = [{ required: false, message: "", trigger: "change" }];
				return;
			}
			if (!this.formCreate.izin_masuk && !this.formCreate.izin_penuh) {
				this.rulesCreate.izin_masuk = [{ required: true, message: "Silakan pilih jenis izin masuk", trigger: "change" }];
				this.rulesCreate.izin_pulang = [{ required: true, message: "Silakan pilih jenis izin pulang", trigger: "change" }];
				this.rulesCreate.izin_penuh = [{ required: true, message: "Silakan pilih jenis izin penuh", trigger: "change" }];
			}
		},
		"formCreate.izin_penuh"(val) {
			if (val) {
				this.formCreate.izin_masuk = null;
				this.formCreate.izin_pulang = null;
				this.rulesCreate.izin_masuk = [{ required: false, message: "", trigger: "change" }];
				this.rulesCreate.izin_pulang = [{ required: false, message: "", trigger: "change" }];
				return;
			}
			if (!this.formCreate.izin_masuk && !this.formCreate.izin_pulang) {
				this.rulesCreate.izin_masuk = [{ required: true, message: "Silakan pilih jenis izin masuk", trigger: "change" }];
				this.rulesCreate.izin_pulang = [{ required: true, message: "Silakan pilih jenis izin pulang", trigger: "change" }];
				this.rulesCreate.izin_penuh = [{ required: true, message: "Silakan pilih jenis izin penuh", trigger: "change" }];
			}
		},
		rowEditing() {
			this.$refs.formEdit.resetFields();
		},
		formEditChanged(val) {
			this.updateEditing(val);
		},
	},
	mounted() {
		this.$ws.main.on("izin:inserted", this.insertedIzin);
		this.$ws.main.on("izin:updated", this.updatedIzin);
		this.$ws.main.on("izin:deleted", this.deletedIzin);
		this.$ws.main.on("user:non-gtk:inserted", this.insertedUser);
		this.$ws.main.on("user:non-gtk:updated", this.updatedUser);
		this.$ws.main.on("user:deleted", this.deletedUser);
		this.getIzinPresensi();
		this.getListUserPresensi();
	},
	beforeUnmount() {
		this.$ws.main.off("izin:inserted");
		this.$ws.main.off("izin:updated");
		this.$ws.main.off("izin:deleted");
		this.$ws.main.off("user:non-gtk:inserted");
		this.$ws.main.off("user:non-gtk:updated");
		this.$ws.main.off("user:deleted");
	},
	beforeRouteLeave(to, from, next) {
		if (this.formEditChanged) {
			const answer = window.confirm("Perubahan belum disimpan. Apakah Anda yakin ingin meninggalkan halaman ini?");
			if (answer) {
				this.updateEditing(false);
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	},
	methods: {
		toWIB(dateStr) {
			const d = new Date(dateStr);
			return new Date(d.getTime() + 7 * 60 * 60 * 1000);
		},
		indexMethod(index) {
			return (this.currentPage - 1) * this.pageSize + index + 1;
		},
		insertedIzin(data) {
			const d = JSON.parse(data);
			if (d.type !== "non_gtk") return;

			if (this.izinFilter.user_presensi_id && this.izinFilter.user_presensi_id !== d.user_presensi_id) return;
			if (Array.isArray(this.izinFilter.tanggal)) {
				const tgl = this.toWIB(d.tanggal);
				const awal = new Date(this.izinFilter.tanggal[0] + "T00:00:00+07:00");
				const akhir = new Date(this.izinFilter.tanggal[1] + "T23:59:59.999+07:00");

				if (tgl < awal || tgl > akhir) return;
			}

			const temp = [...this.izinPresensi];
			temp.push(d);

			temp.sort((a, b) => {
				const tglA = new Date(a.tanggal);
				const tglB = new Date(b.tanggal);

				return tglA - tglB || a.nama.localeCompare(b.nama);
			});

			const checkIndex = temp.findIndex((t) => t.izin_presensi_id === d.izin_presensi_id);
			if (checkIndex === this.pageSize) {
				this.totalData++;
				return;
			}
			if (checkIndex === 0 && this.currentPage > 1) {
				this.getIzinPresensi();
				return;
			}

			this.izinPresensi.splice(checkIndex, 0, {
				izin_presensi_id: d.izin_presensi_id,
				user_presensi_id: d.user_presensi_id,
				tanggal: d.tanggal,
				izin_masuk: d.izin_masuk ? d.izin_masuk.toUpperCase() : null,
				izin_pulang: d.izin_pulang ? d.izin_pulang.toUpperCase() : null,
				izin_penuh: d.izin_penuh ? d.izin_penuh.toUpperCase() : null,
				keterangan: d.keterangan,
				is_confirmed: d.is_confirmed,
				nama: d.nama,
				tanggal_izin: new Date(d.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
				created_at: new Date().toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
				updated_at: null,
			});

			if (this.izinPresensi.length > this.pageSize) this.izinPresensi.pop();

			this.totalData++;
		},
		updatedIzin(data) {
			const d = JSON.parse(data);
			const oldData = d.old_data;

			if (oldData.type !== "non_gtk") return;

			if (
				this.izinFilter.user_presensi_id &&
				this.izinFilter.user_presensi_id !== oldData.user_presensi_id &&
				d.user_presensi_id &&
				this.izinFilter.user_presensi_id !== d.user_presensi_id
			)
				return;

			let oldOutRange = false;
			let newOutRange = false;
			if (Array.isArray(this.izinFilter.tanggal)) {
				const oldTgl = this.toWIB(oldData.tanggal);
				const newTgl = this.toWIB(d.tanggal);
				const awal = new Date(this.izinFilter.tanggal[0] + "T00:00:00+07:00");
				const akhir = new Date(this.izinFilter.tanggal[1] + "T23:59:59.999+07:00");
				oldOutRange = oldTgl < awal || oldTgl > akhir;
				newOutRange = newTgl < awal || newTgl > akhir;
			}
			if (oldOutRange && d.tanggal && newOutRange) return;

			const totalPages = Math.ceil(this.totalData / this.pageSize);
			const oldDataIndex = this.izinPresensi.findIndex((ip) => ip.izin_presensi_id === d.izin_presensi_id);
			const newData = {
				izin_presensi_id: d.izin_presensi_id,
				user_presensi_id: d.user_presensi_id || oldData.user_presensi_id,
				tanggal: d.tanggal || oldData.tanggal,
				tanggal_izin: new Date(d.tanggal || oldData.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
				izin_masuk: d.izin_masuk ? d.izin_masuk.toUpperCase() : d.izin_masuk === 0 || d.izin_penuh ? null : oldData.izin_masuk,
				izin_pulang: d.izin_pulang ? d.izin_pulang.toUpperCase() : d.izin_pulang === 0 || d.izin_penuh ? null : oldData.izin_pulang,
				izin_penuh: d.izin_penuh ? d.izin_penuh.toUpperCase() : d.izin_masuk || d.izin_pulang ? null : oldData.izin_penuh,
				keterangan: d.keterangan === 0 ? null : oldData.keterangan,
				created_at: new Date(oldData.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
				updated_at: new Date(d.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
				is_confirmed: d.user_presensi_id ? d.is_confirmed : oldData.is_confirmed,
				nama: d.nama || oldData.nama,
			};

			if (oldDataIndex !== -1) {
				if (this.rowEditing && this.rowEditing.izin_presensi_id === d.izin_presensi_id) this.rowEditing = null;

				if (!d.tanggal && !d.user_presensi_id) {
					const existData = this.izinPresensi[oldDataIndex];

					if (d.izin_masuk) {
						existData.izin_masuk = d.izin_masuk.toUpperCase();
						existData.izin_penuh = null;
					} else if (d.izin_masuk === 0) {
						existData.izin_masuk = null;
					}

					if (d.izin_pulang) {
						existData.izin_pulang = d.izin_pulang.toUpperCase();
						existData.izin_penuh = null;
					} else if (d.izin_pulang === 0) {
						existData.izin_pulang = null;
					}

					if (d.izin_penuh) {
						existData.izin_masuk = null;
						existData.izin_masuk = null;
						existData.izin_penuh = d.izin_penuh.toUpperCase();
					}

					if (d.keterangan || d.keterangan === 0) existData.keterangan = d.keterangan;

					existData.updated_at = d.updated_at ? new Date(d.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }) : null;
					return;
				}

				this.izinPresensi.splice(oldDataIndex, 1);
				const temp = [...this.izinPresensi];

				temp.push(newData);

				temp.sort((a, b) => {
					const tglA = new Date(a.tanggal);
					const tglB = new Date(b.tanggal);

					return tglA - tglB || a.nama.localeCompare(b.nama);
				});

				const checkIndex = temp.findIndex((t) => t.izin_presensi_id === d.izin_presensi_id);
				if ((checkIndex === 0 && this.currentPage > 1) || (checkIndex === this.izinPresensi.length && this.currentPage < totalPages)) {
					this.getIzinPresensi();
					return;
				}

				this.izinPresensi.splice(checkIndex, 0, newData);
				return;
			}

			if (!d.tanggal && !d.user_presensi_id) return;

			const tempOld = [...this.izinPresensi];
			const tempNew = [...this.izinPresensi];

			tempOld.push(oldData);
			tempNew.push(newData);

			tempOld.sort((a, b) => {
				const tglA = new Date(a.tanggal);
				const tglB = new Date(b.tanggal);

				return tglA - tglB || a.nama.localeCompare(b.nama);
			});
			tempNew.sort((a, b) => {
				const tglA = new Date(a.tanggal);
				const tglB = new Date(b.tanggal);

				return tglA - tglB || a.nama.localeCompare(b.nama);
			});

			const checkOldIndex = tempOld.findIndex((t) => t.izin_presensi_id === d.izin_presensi_id);
			const checkNewIndex = tempNew.findIndex((t) => t.izin_presensi_id === d.izin_presensi_id);

			if ((checkOldIndex === 0 && checkNewIndex === 0) || (checkOldIndex === this.pageSize && checkNewIndex === this.pageSize)) return;
			if ((checkOldIndex === 0 && checkNewIndex === this.pageSize) || (checkOldIndex === this.pageSize && checkNewIndex === 0)) {
				this.getIzinPresensi();
				return;
			}

			if (checkOldIndex === 0) {
				this.izinPresensi.splice(checkNewIndex, 0, newData);
				this.izinPresensi.shift();
				return;
			}
			if (checkOldIndex === this.pageSize) {
				this.izinPresensi.splice(checkNewIndex, 0, newData);
				this.izinPresensi.pop();
				return;
			}
		},
		deletedIzin(data) {
			const d = JSON.parse(data);
			if (d.type !== "non_gtk") return;

			if (this.izinFilter.user_presensi_id && this.izinFilter.user_presensi_id !== d.user_presensi_id) return;
			if (Array.isArray(this.izinFilter.tanggal)) {
				const tgl = this.toWIB(d.tanggal);
				const awal = new Date(this.izinFilter.tanggal[0] + "T00:00:00+07:00");
				const akhir = new Date(this.izinFilter.tanggal[1] + "T23:59:59.999+07:00");

				if (tgl < awal || tgl > akhir) return;
			}

			const totalPages = Math.ceil(this.totalData / this.pageSize);
			const oldDataIndex = this.izinPresensi.findIndex((ip) => ip.izin_presensi_id === d.izin_presensi_id);

			if (oldDataIndex !== -1) {
				if (this.rowEditing && this.rowEditing.izin_presensi_id === d.izin_presensi_id) this.rowEditing = null;

				if (this.currentPage === totalPages) {
					this.izinPresensi.splice(oldDataIndex, 1);
					this.totalData--;
					return;
				}

				this.getIzinPresensi();
				return;
			}

			const temp = [...this.izinPresensi];

			temp.push(d);
			temp.sort((a, b) => {
				const tglA = new Date(a.tanggal);
				const tglB = new Date(b.tanggal);

				return tglA - tglB || a.nama.localeCompare(b.nama);
			});

			const checkIndex = temp.findIndex((t) => t.izin_presensi_id === d.izin_presensi_id);
			if (checkIndex === this.pageSize) {
				this.totalData--;
				return;
			}
			if (checkIndex === 0 && this.currentPage === totalPages) {
				this.izinPresensi.shift();
				this.totalData--;
				return;
			}

			this.getIzinPresensi();
		},
		cellClass({ row }) {
			if (this.rowEditing === row) {
				return "align-top";
			}
			return "";
		},
		insertedUser(data) {
			const d = JSON.parse(data);

			const temp = [...this.listUser];
			temp.push(d);
			temp.sort((a, b) => {
				return a.nama.localeCompare(b.nama);
			});

			const checkIndex = temp.findIndex((t) => t.user_presensi_id === d.user_presensi_id);
			this.listUser.splice(checkIndex, 0, {
				user_presensi_id: d.user_presensi_id,
				non_gtk_id: d.non_gtk_id,
				nama: d.nama,
			});
		},
		updatedUser(data) {
			const d = JSON.parse(data);

			this.listUser.every((u) => {
				if (u.non_gtk_id === d.non_gtk_id) {
					if (d.user_presensi_id) u.user_presensi_id = d.user_presensi_id;

					return false;
				}
				return true;
			});
			this.izinPresensi.forEach((i) => {
				if (i.non_gtk_id === d.non_gtk_id) {
					if (d.user_presensi_id) i.user_presensi_id = d.user_presensi_id;
					if (typeof d.is_confirmed === "number") i.is_confirmed = d.is_confirmed;
				}
			});
		},
		deletedUser(data) {
			const d = JSON.parse(data);
			if (d.type !== "non_gtk") return;

			const oldUserIndex = this.listUser.findIndex((u) => u.user_presensi_id === d.user_presensi_id);
			if (oldUserIndex !== -1) this.listUser.splice(oldUserIndex, 1);
		},
		confirmDelete(row) {
			this.$confirm("", "Perhatian", {
				message: h("div", {}, [
					"Anda yakin ingin menghapus izin presensi ",
					h("strong", row.nama),
					" tanggal ",
					h("strong", new Date().toLocaleDateString("id-ID", { dateStyle: "long" })),
					"?",
				]),
				confirmButtonText: "Ya, hapus",
				cancelButtonText: "Batal",
				type: "warning",
			})
				.then(() => this.deleteIzinPresensi(row))
				.catch(() => {});
		},
		async getIzinPresensi() {
			this.loading = true;
			try {
				const { data } = await this.$defaultApi.post("/izin", {
					user_presensi_type: "non_gtk",
					user_presensi_id: this.izinFilter.user_presensi_id,
					tanggal_awal: Array.isArray(this.izinFilter.tanggal) ? this.izinFilter.tanggal[0] : null,
					tanggal_akhir: Array.isArray(this.izinFilter.tanggal) ? this.izinFilter.tanggal[1] : null,
					limit: this.pageSize,
					offset: (this.currentPage - 1) * this.pageSize,
				});

				const izin = data.izin.map((i) => ({
					...i,
					tanggal_izin: new Date(i.tanggal).toLocaleDateString("id-ID", { dateStyle: "full" }),
					created_at: new Date(i.created_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }),
					updated_at: i.updated_at ? new Date(i.updated_at).toLocaleString("id-ID", { dateStyle: "medium", timeStyle: "medium" }) : null,
				}));

				await new Promise((resolve) => setTimeout(resolve, 500));
				this.izinPresensi = izin;
				this.totalData = data.count;
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.loading = false;
			}
		},
		async getListUserPresensi() {
			try {
				const { data } = await this.$defaultApi.post("/user/list", {
					user_presensi_type: "non_gtk",
				});

				this.listUser = data.list_user;
			} catch (error) {
				console.error(error);
			}
		},
		async insertIzinPresensi() {
			this.inserting = true;
			try {
				const valid = await this.$refs.formCreate.validate((res) => {
					return res;
				});
				if (!valid) {
					throw Error("Silakan masukkan isian sesuai dengan ketentuan");
				}

				const { data } = await this.$defaultApi.post("/izin/create", this.formCreate);

				this.$refs.formCreate.resetFields();
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.inserting = false;
				}, 500);
			}
		},
		async updateIzinPresensi() {
			this.updating = true;
			try {
				if (!this.formEditChanged) {
					throw Error("Anda belum melakukan perubahan");
				}

				const { data } = await this.$defaultApi.post("/izin/update", {
					izin_presensi_id: this.rowEditing.izin_presensi_id,
					user_presensi_id: this.formEdit.user_presensi_id,
					tanggal: this.formEdit.tanggal,
					izin_masuk: this.formEdit.del_izin_masuk ? 0 : this.formEdit.izin_masuk,
					izin_pulang: this.formEdit.del_izin_pulang ? 0 : this.formEdit.izin_pulang,
					izin_penuh: this.formEdit.izin_penuh,
					keterangan: this.formEdit.del_keterangan ? 0 : this.formEdit.keterangan,
				});

				this.rowEditing = null;
				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.updating = false;
				}, 500);
			}
		},
		async deleteIzinPresensi(row) {
			this.deleting = true;
			try {
				const { data } = await this.$defaultApi.post("/izin/delete", {
					izin_presensi_id: row.izin_presensi_id,
				});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
					});
				}

				console.error(error);
				this.$notify.warning({
					title: "Perhatian",
					message: error.message,
				});
			} finally {
				setTimeout(() => {
					this.deleting = false;
				}, 500);
			}
		},
		async syncRekapPresensi() {
			this.syncing = true;
			try {
				const { data } = await this.$defaultApi.post("/izin/sync-izin", {});

				this.$notify.success({
					title: "Berhasil",
					message: data.message,
				});
			} catch (error) {
				if (error.response) {
					console.error(error.response.data.errMessage);
					return this.$notify.error({
						title: error.response.data.error || "Gagal",
						message: error.response.data.message,
						showClose: false,
					});
				}

				console.log(error);
			} finally {
				this.syncing = false;
			}
		},
	},
};
</script>

<style scoped></style>
